require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./brand-design-sandy-springs.json") })
        }
      }, "path---brand-design-sandy-springs");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---brand-design-sandy-springs!./.cache/json/brand-design-sandy-springs.json
// module id = 383
// module chunks = 231608221292675